import { render, staticRenderFns } from "./form-applications.vue?vue&type=template&id=4a1856ac"
import script from "./form-applications.vue?vue&type=script&lang=js"
export * from "./form-applications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports